// Imports ------------------------------------------------------------------->

import {inject} from "../di";
import {ILoyaltyCardProvider} from "../definitions/ILoyaltyCardProvider";
import {AuthUser} from "../definitions/IAuthenticationService";
import {AccountsUser, LoyaltyCardJSON, ToastLevel} from "../../definitions/CommonDefinitions";
import {PostcardService, SessionJSON} from "../PostcardService";
import * as array from "../../utils/array";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

export class PGCardProvider implements ILoyaltyCardProvider {

	@inject postcardService: PostcardService;

	private _loyaltyCardsJSON: Promise<LoyaltyCardJSON>;

	constructor() {
		window.addEventListener("flipp-auth", this.clear);
	}

	getLoyaltyCards(user: AuthUser) {
		if (!this._loyaltyCardsJSON) {
			this._loyaltyCardsJSON = new Promise((resolve, reject) => {
				this.postcardService.getLoyaltyCards(user.info.id).then((session: SessionJSON) => {
					const result = {
						loyalty_cards: []
					} as LoyaltyCardJSON;
					session.cards.forEach((card) => {
						result.loyalty_cards.push({
							card_id: card.card_id,
							commit_version: 1,
							created_at: new Date(),
							id: null,
							loyalty_program_id: card.loyalty_program_id,
							name: null,
							phone_number: card.phone,
							updated_at: new Date(),
							registered: true,
							token: card.token
						});
					});
					resolve(result);
				}).catch((err: Error) => {
					resolve({
						loyalty_cards: []
					} as LoyaltyCardJSON);
				});
			});
		}
		return this._loyaltyCardsJSON;
	}

	clear() {
		this._loyaltyCardsJSON = null;
	}
}
